import { get, post, put, patch } from "../../../services/api/Config"

const _api_route = `business-purpose`

export function SearchContent(section, { params = {}, lang }) {
  return get({ url: `/v1/admin/${_api_route}/${section}`, params, lang })
}
export function GetContentById(section, id, { lang }) {
  return get({ url: `/v1/admin/${_api_route}/${section}/${id}`, lang })
}
export function CreateContent(section, { params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/${_api_route}/${section}`, params, data, lang })
}
export function UpdateContent(section, id, { params = {}, data = {}, lang }) {
  return put({ url: `/v1/admin/${_api_route}/${section}/${id}`, params, data, lang })
}
export function PatchContent(section, id, { params = {}, data = {}, lang }) {
  return patch({ url: `/v1/admin/${_api_route}/${section}/${id}`, params, data, lang })
}
export function DeleteContent(section, { params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/${_api_route}/${section}/mutiDelete`, params, data, lang })
}



export function SearchPerformanceContent({ params = {}, lang }) {
  return get({ url: `/v1/admin/${_api_route}/performance`, params, lang })
}
export function GetPerformanceContentById(id, { lang }) {
  return get({ url: `/v1/admin/${_api_route}/performance/${id}`, lang })
}
export function CreatePerformanceContent({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/${_api_route}/performance`, params, data, lang })
}
export function UpdatePerformanceContent(id, { params = {}, data = {}, lang }) {
  return put({ url: `/v1/admin/${_api_route}/performance/${id}`, params, data, lang })
}
export function PatchPerformanceContent(id, { params = {}, data = {}, lang }) {
  return patch({ url: `/v1/admin/${_api_route}/performance/${id}`, params, data, lang })
}
export function DeletePerformanceContent({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/${_api_route}/performance/mutiDelete`, params, data, lang })
}







export function SearchWorldclassContent({ params = {}, lang }) {
  return get({ url: `/v1/admin/${_api_route}/worldclass`, params, lang })
}
export function GetWorldclassContentById(id, { lang }) {
  return get({ url: `/v1/admin/${_api_route}/worldclass/${id}`, lang })
}
export function CreateWorldclassContent({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/${_api_route}/worldclass`, params, data, lang })
}
export function UpdateWorldclassContent(id, { params = {}, data = {}, lang }) {
  return put({ url: `/v1/admin/${_api_route}/worldclass/${id}`, params, data, lang })
}
export function PatchWorldclassContent(id, { params = {}, data = {}, lang }) {
  return patch({ url: `/v1/admin/${_api_route}/worldclass/${id}`, params, data, lang })
}
export function DeleteWorldclassContent({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/${_api_route}/worldclass/mutiDelete`, params, data, lang })
}
